import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { TextareaModule } from 'primeng/textarea';
import { Nl2brPipe } from '@app/core/pipes';
import { InputBlockEmitter } from '../block-input/block-input';
import { InputService } from '@app/core/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-block-textarea',
  imports: [
    CommonModule,
    FormsModule,
    TextareaModule,
    ButtonModule,
    ButtonGroupModule,
    AutoFocusModule,
    Nl2brPipe,
  ],
  templateUrl: './block-textarea.html'
})
export class BlockTextarea implements OnInit {
  @Input() object!: any;
  @Input() label!: string;
  @Input() property!: string;
  @Input() class!: 'Product' | 'EbayProduct' | 'EbayStock';

  @Output() objectChange = new EventEmitter<any>(); // For two way binding of [(object)]
  @Output() isSendingData = new EventEmitter<InputBlockEmitter>();

  isEditMode: boolean = false;

  isSendingInputData: boolean = false;

  value: any = null;
  defaultValue: any = this.value;

  constructor(
    private inputService: InputService
  ) { }

  ngOnInit(): void {
    this.value = this.property in this.object ? this.object[this.property] : '';
    this.defaultValue = this.property in this.object ? this.object[this.property] : '';
  }

  onToggleMode() {
      this.isEditMode = !this.isEditMode;
    }
  
    onInputClose() {
      this.value = this.defaultValue;
      this.onToggleMode();
    }
  
    onSaveComment() {
      this.onToggleMode();
  
      if (this.defaultValue !== this.value) {
        this.isSendingInputData = true;
        this.isSendingData.emit({ property: this.property, isSendingData: true });
    
        const data: any = {};
        data[this.property] = this.value;
    
        let observable: Observable<any>;
        
        switch (this.class) {
          case 'Product':
            observable = this.inputService.patchProduct(this.object.id, data)
            break;
          case 'EbayProduct':
            observable = this.inputService.patchEbayProduct(this.object.id, data)
            break;
          case 'EbayStock':
            observable = this.inputService.patchEbayStock(this.object.id, data)
            break;
        }
  
        if (!observable) return;
        
        observable.subscribe({
          next: (obj: any) => {
            this.object = { ...this.object, ...data };
            this.defaultValue = this.value;
          },
          complete: () => {
            this.isSendingInputData = false;
            this.objectChange.emit(this.object);
            this.isSendingData.emit({ property: this.property, isSendingData: false, message: { severity: 'info', summary: 'Modification', detail: `${this.label} a été changé avec succès` } });
          }
        });
      }
    }
}
